module.exports = __webpack_public_path__ + "static/media/shuttleInspectionIcon.3b357883.png";